import React from 'react';
import { useTheme } from '@mui/material/styles';

const LanternalLogo = ({ size = 35, environment, ...props }) => {
  const theme = useTheme();
  const logoSrc = theme.palette.mode === 'dark' ? '/static/console-white-mark.svg' : '/static/console-black-mark.svg';

  return (
    <img
      alt="Console Logo"
      src={logoSrc}
      style={{
        width: size,
        height: size,
      }}
      {...props}
    />
  );
};

export default LanternalLogo;
